// Standard library imports
import React, { useState, useEffect } from 'react';

// Internal module imports
import { timeOnly } from '../../../utils/dateHelper';
import { useLoader } from '../../../hooks';

// Css imports
import classes from '../../DemandResponse/DemandResponse.module.css';
import TabsComponent from '../../../components/Tabs/Tabs';
import EChart from '../../../components/Echarts/Echarts';
import { usToEuCurrencyFormat } from '../../../utils/currencyHelper';
import myClasses from '../../SmartCharging/SmartCharging.module.css';
import Typography from '../../../components/Typography/Typography';
import { EventsService } from '../../../services/EventsService';

const DataLogModal = ({ data, setOpen, }) => {
    const [startLoader, stopLoader] = useLoader();
    const [graphData, setGraphData] = useState([]);
    const [consumptionData, setConsumptionData] = useState([]);
    const [socData, setSocData] = useState([]);
    const [selectedIndex] = useState(0);

    useEffect(() => {
        getDataLog();
    }, [data?.instanceId]);

    const getDataLog = () => {
        if (data?.instanceId) {
            let filteredParams = {
                instanceId: data?.instanceId,
                startTime: data.startTime,
                endTime: data.endTime !== '--' ? data.endTime : ''
            };
            EventsService.GetDataLog(filteredParams, startLoader, handleSuccess, handleError, stopLoader);
        }
    };

    const handleSuccess = ({ data }) => {
        setGraphData(data.data.powerData);
        setConsumptionData(data.data.consumptionData || [{ data: [] }]);
        setSocData(data.data.socData || [{ data: [] }]);
    };

    const handleError = (err) => {
        console.error(err);
    };

    let tabs = [
        {
            name: 'Power (kW)',
            component: (
                <div>
                    <EChart series={graphData} type="line" xFormatter={timeOnly} yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))} yTooltipSuffix={['kW']} />
                </div>
            ),
        },
        {
            name: 'Consumption (kWh)',
            component: (
                <div>
                    <EChart
                        series={consumptionData}
                        type="line"
                        lineType={'area'}
                        xFormatter={timeOnly}
                        yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))}
                        yTooltipSuffix={['kWh']}
                    />
                </div>
            ),
        },
        {
            name: 'SoC (%)',
            component: (
                <div>
                    <EChart series={socData} type="line" xFormatter={timeOnly} yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))} yTooltipSuffix={['%']} />
                </div>
            ),
        },
    ];

    return (
        <div style={{ width: '50vw', maxHeight: '90vh' }}>
            <div className={myClasses.FilterContainer}>
                <div className={myClasses.HeadingContainer}>
                    <Typography content={`Data Log`} />
                </div>
            </div>

            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
            />
            <div className={classes.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default DataLogModal;
